import { Ref } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from './_http';

// type GetExcelParams = {
// 	master_pk: number;
// };
type File = {
	file_path: string;
	file_original_name?: string;
};

// export const useGetHTSExcelApi = (params: Ref<GetExcelParams>) => {
// 	const url = '/v1/front/getHTSExcel';
// 	return useQuery<AxiosResponse, AxiosError, File>({
// 		queryKey: [url, params],
// 		queryFn: () => api.get(url, params.value),
// 		select: (res) => res.data?.data,
// 		enabled: false,
// 	});
// };

export type GetHTSPathDataType = {
	file: File;
};

export const useGetHTSPathApi = (params: Ref) => {
	const url = '/v1/front/getHTSPath';
	return useQuery<AxiosResponse, AxiosError, GetHTSPathDataType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		enabled: false,
	});
};

export const useGetSimpleInfoExcelApi = (params: Ref) => {
	const url = '/v1/front/getSimpleInfoExcel';
	return useQuery<AxiosResponse, AxiosError, File>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		enabled: false,
	});
};

//결제 확인
export type GetPaymentCheckParamsType = {
	subscription_pk: string | string[];
};
export type GetPaymentCheckResType = CommonResType;
export const useGetAosPaymentCheckApi = () => {
	const url = '/v1/front/aosPaymentCheck';
	return useMutation<AxiosResponse<GetPaymentCheckResType>, AxiosError, GetPaymentCheckParamsType>({
		mutationFn: (data: GetPaymentCheckParamsType) => api.post(url, data),
	});
};
export const useGetIosPaymentCheckApi = () => {
	const url = '/v1/front/iosPaymentCheck';
	return useMutation<AxiosResponse<GetPaymentCheckResType>, AxiosError, GetPaymentCheckParamsType>({
		mutationFn: (data: GetPaymentCheckParamsType) => api.post(url, data),
	});
};
